import { checkDefined, IllegalArgumentError } from 'faro-common-model';
import { toBaseStudyEntity } from './study-entity.js';
import { toActivityScheduleRuleType } from './activity-schedule-rule-type.js';
import { StudyEntityType } from './study-entity-type.js';
import { toExcludedDay } from './exclude-day.js';
export const activityScheduleRuleDescriptionMaxLength = 2000;
export const activityScheduleRuleCardinalityMax = 20;
export const defaultCardinality = 1;
export function toActivityScheduleRule(rule) {
    var _a, _b, _c;
    checkDefined(rule.scheduleOfActivitiesId, 'ActivityScheduleRule', 'scheduleOfActivitiesId');
    checkDefined(rule.activityId, 'ActivityScheduleRule', 'activityId');
    checkDefined(rule.epochId, 'ActivityScheduleRule', 'epochId');
    checkDefined(rule.type, 'ActivityScheduleRule', 'type');
    if (['fixed', 'non-fixed-day', 'custom-non-reported', 'custom-reported', 'recurring'].includes(rule.type))
        checkDefined(rule.epochDay, 'ActivityScheduleRule', 'epochDay');
    if (['non-fixed-day', 'custom-non-reported', 'custom-reported', 'recurring'].includes(rule.type))
        checkDefined(rule.endEpochDay, 'ActivityScheduleRule', 'endEpochDay');
    if (rule.type === 'recurring') {
        checkDefined(rule.interval, 'ActivityScheduleRule', 'interval');
        checkDefined(rule.intervalDuration, 'ActivityScheduleRule', 'intervalDuration');
    }
    if (['custom-reported', 'recurring', 'non-fixed-day'].includes(rule.type) &&
        rule.excludedDays &&
        !Array.isArray(rule.excludedDays)) {
        throw new IllegalArgumentError(`ActivityScheduleRule.excludedDays must be an array`);
    }
    if (['fixed', 'non-fixed-day'].includes(rule.type) && rule.cycles) {
        if (!Array.isArray(rule.cycles)) {
            throw new IllegalArgumentError(`ActivityScheduleRule.cycles must be an array`);
        }
        if (rule.cycles.some((cycle) => typeof cycle !== 'number')) {
            throw new IllegalArgumentError(`ActivityScheduleRule.cycles must be an array of numbers`);
        }
    }
    return {
        ...toBaseStudyEntity(rule, StudyEntityType.ActivityScheduleRule),
        type: toActivityScheduleRuleType(rule.type),
        scheduleOfActivitiesId: rule.scheduleOfActivitiesId,
        activityId: rule.activityId,
        epochId: rule.epochId,
        epochDay: ['fixed', 'non-fixed-day', 'custom-non-reported', 'custom-reported', 'recurring'].includes(rule.type)
            ? rule.epochDay
            : undefined,
        endEpochDay: ['non-fixed-day', 'custom-non-reported', 'custom-reported', 'recurring'].includes(rule.type)
            ? rule.endEpochDay
            : undefined,
        description: rule.description,
        cardinality: (_a = rule.cardinality) !== null && _a !== void 0 ? _a : defaultCardinality,
        interval: rule.type === 'recurring' ? rule.interval : undefined,
        intervalDuration: rule.type === 'recurring' ? rule.intervalDuration : undefined,
        endEpochId: ['custom-non-reported', 'custom-reported', 'recurring'].includes(rule.type)
            ? ((_b = rule.endEpochId) !== null && _b !== void 0 ? _b : rule.epochId)
            : undefined,
        startCycle: ['custom-non-reported', 'custom-reported', 'recurring'].includes(rule.type)
            ? rule.startCycle
            : undefined,
        endCycle: ['custom-non-reported', 'custom-reported', 'recurring'].includes(rule.type) && rule.startCycle
            ? rule.endCycle
            : undefined,
        cycles: ['fixed', 'non-fixed-day'].includes(rule.type) ? rule.cycles : undefined,
        excludedDays: ['custom-reported', 'recurring', 'non-fixed-day'].includes(rule.type) && rule.excludedDays
            ? rule.excludedDays.map((day) => toExcludedDay(day))
            : undefined,
        showAllDays: rule.type === 'recurring' ? ((_c = rule.showAllDays) !== null && _c !== void 0 ? _c : true) : true,
    };
}
//# sourceMappingURL=activity-schedule-rule.js.map